var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.0625C19.7772 12.0625 20.8125 11.0272 20.8125 9.75C20.8125 8.47284 19.7772 7.4375 18.5 7.4375C17.2228 7.4375 16.1875 8.47284 16.1875 9.75C16.1875 11.0272 17.2228 12.0625 18.5 12.0625Z",
    fill: "#919B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.3125C19.7772 21.3125 20.8125 20.2772 20.8125 19C20.8125 17.7228 19.7772 16.6875 18.5 16.6875C17.2228 16.6875 16.1875 17.7228 16.1875 19C16.1875 20.2772 17.2228 21.3125 18.5 21.3125Z",
    fill: "#919B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.5625C19.7772 30.5625 20.8125 29.5272 20.8125 28.25C20.8125 26.9728 19.7772 25.9375 18.5 25.9375C17.2228 25.9375 16.1875 26.9728 16.1875 28.25C16.1875 29.5272 17.2228 30.5625 18.5 30.5625Z",
    fill: "#919B9B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.fea614681ca56fee239dec26930fcf6c.svg";
export { ForwardRef as ReactComponent };